var map = {
	"./btn-icon-1.png": "8bb4",
	"./btn-icon-2.png": "754f",
	"./btn-icon-3.png": "18c2",
	"./btn-icon-4.png": "772e",
	"./client-code.png": "0af1",
	"./down-icon.png": "6d02",
	"./five.png": "ed6a",
	"./four.png": "b87e",
	"./header-bg.jpg": "d2cb",
	"./kf-large-icon.png": "d755",
	"./mc-app-supplier.png": "0aaa",
	"./mc-app.png": "05a2",
	"./mc-code.png": "c99f",
	"./mc-wb.png": "5b10",
	"./mc-wx.png": "d6bd",
	"./news-01.png": "5b28",
	"./news-010.jpg": "6825",
	"./news-02.png": "c126",
	"./news-03.png": "2fa6",
	"./news-04.png": "9859",
	"./news-05.jpg": "8a57",
	"./news-06.jpg": "6c37",
	"./news-07.jpg": "d260",
	"./news-08.jpg": "290b",
	"./one.png": "bc1e",
	"./picture.png": "f425",
	"./seven.png": "5eaa",
	"./shop-icon.png": "b4690",
	"./six.png": "7bed",
	"./slide-01.png": "3e35",
	"./three.png": "71d8",
	"./two.png": "88ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a87c";